import { Box } from 'approot/shared/design-system/box/box.style';
import { LinkButton } from 'approot/shared/styles/buttons/link-button.style';
import ClassRoomStudentAnswerDropdown from './classroom-student-answer-dropdown';
import { Student } from './classroom.constants';
import { useActivityBuilderPresentContext } from '../present/activity-builder-present.context';
import ClassroomAnswerStudentVisibility from './classroom-answer-student-visibility';
import * as Styled from './classroom-answer-detail-header.style';

type Props = {
  studentId: number;
  students: Student[];
  onSelect: (id: number) => void;
};

const ClassroomAnswerDetailHeader = ({
  studentId,
  students,
  onSelect,
}: Props) => {
  const { isStudentNamesVisible } = useActivityBuilderPresentContext();

  return (
    <Box>
      <div>
        <Styled.ClassroomAnswerDetailHeaderButtons
          $marginBottom={isStudentNamesVisible ? 16 : 24}
        >
          <LinkButton onClick={() => onSelect(0)}>
            Back to all responses
          </LinkButton>
          <ClassroomAnswerStudentVisibility />
        </Styled.ClassroomAnswerDetailHeaderButtons>
      </div>
      {isStudentNamesVisible && (
        <Styled.ClassroomAnswerDetailHeaderPicker>
          <ClassRoomStudentAnswerDropdown
            selectedStudentId={studentId}
            students={students}
            onSelect={onSelect}
          />
        </Styled.ClassroomAnswerDetailHeaderPicker>
      )}
    </Box>
  );
};

export default ClassroomAnswerDetailHeader;
